var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeartEmpty(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 9.793l-1.42-1.431c-.467-.472-1.158-1.093-1.952-1.586C9.816 6.272 9.053 6 8.402 6c-1.604 0-2.648.471-3.29 1.112C4.473 7.752 4 8.795 4 10.398c0 1.067.494 2.177 1.143 3.137a9.616 9.616 0 001.24 1.493.032.032 0 01.003.004l.036.032 7.579 7.464 7.53-7.403.012-.012c.167-.165.739-.726 1.312-1.574.651-.965 1.145-2.074 1.145-3.14 0-1.604-.472-2.647-1.113-3.287C22.246 6.472 21.202 6 19.598 6c-.651 0-1.414.272-2.226.776-.794.493-1.485 1.114-1.952 1.586L14 9.792zm8.933 6.758l-8.344 8.203A.822.822 0 0114 25a.822.822 0 01-.59-.246l-8.356-8.23C4.946 16.427 2 13.68 2 10.397 2 6.393 4.397 4 8.402 4c2.228 0 4.323 1.705 5.433 2.79.058.056.113.11.165.163l.165-.164C15.275 5.705 17.37 4 19.598 4 23.603 4 26 6.393 26 10.398c0 3.155-2.724 5.817-3.04 6.127a2.161 2.161 0 00-.027.026z"
  })));
}

export default SvgHeartEmpty;